import type { Diagnostics } from "./Diagnostics.js";

export function formatDiagnostics(
	inner: Diagnostics,
	format: (type: keyof Diagnostics, ...data: unknown[]) => unknown[],
): Diagnostics {
	function logFor(type: keyof Diagnostics) {
		return function log(...data: unknown[]): void {
			inner[type](...format(type, ...data));
		};
	}

	return {
		debug: logFor("debug"),
		error: logFor("error"),
		info: logFor("info"),
		trace: logFor("trace"),
		warn: logFor("warn"),
	};
}
